import { FC, ReactElement } from 'react';

import { LocaleSwitcher } from '../../containers';
import { Locale } from '../../helpers/trans';
import { updateLocale } from '../../redux/app/appActions';
import { useTypedDispatch, useTypedSelector } from '../../redux/store';

interface ConnectedLocaleSwitcherProps {
    className?: string;
}

const ConnectedLocaleSwitcher: FC<ConnectedLocaleSwitcherProps> = ({ className = '' }): ReactElement => {
    const dispatch = useTypedDispatch();

    const locale = useTypedSelector(state => state.appReducer.locale);

    const handleLocaleChange = (preferredLocale: Locale): void => {
        dispatch(updateLocale(preferredLocale));
    };

    return (
        <LocaleSwitcher
            locale={locale}
            onLocaleChange={handleLocaleChange}
            className={className}
        />
    );
};

export default ConnectedLocaleSwitcher;
